module.exports = __webpack_public_path__ + "static/monei_pay_1_en-1182fa09564586ffb1f284b27c0201c5.png";